"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndicatorConfig = exports.DefaultConfig = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var DefaultConfig = exports.DefaultConfig = {
  componentName: 'fuse-password-indicator'
};
var IndicatorConfig = exports.IndicatorConfig = {
  weak: {
    colour: 'var(--color-functional-errorMid)',
    colourCountIndex: 1,
    label: 'Weak',
    keyId: (0, _fuseUtils.namedUuid)()
  },
  moderate: {
    colour: 'var(--color-functional-warningMid)',
    colourCountIndex: 2,
    label: 'Moderate',
    keyId: (0, _fuseUtils.namedUuid)()
  },
  strong: {
    colour: 'var(--color-functional-successMid)',
    colourCountIndex: 3,
    label: 'Strong',
    keyId: (0, _fuseUtils.namedUuid)()
  },
  veryStrong: {
    colour: 'var(--color-functional-successMid)',
    colourCountIndex: 4,
    label: 'Very strong',
    keyId: (0, _fuseUtils.namedUuid)()
  }
};